import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AccommodationProviders from './AccommodationProviders';
import Doctors from './Doctors';
import HolidayHomes from './HolidayHomes';
import HolidaysPark from './HolidaysPark';
import RetirementHomes from './RetirementHomes';
import QuarantineBot from './QuarantineBot';
import Salons from './Salons';
import VirtualVetNurse from './VirtualVetNurse';
import Tourism from './Tourism';
import Northable from './Northable';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route
        path={`${match.url}/accommodationproviders`}
        component={AccommodationProviders}
      />
      <Route path={`${match.url}/doctors`} component={Doctors} />
      <Route path={`${match.url}/holidayhomes`} component={HolidayHomes} />
      <Route path={`${match.url}/holidaypark`} component={HolidaysPark} />
      <Route
        path={`${match.url}/retirementhomes`}
        component={RetirementHomes}
      />
      <Route path={`${match.url}/quarantinebot`} component={QuarantineBot} />
      <Route path={`${match.url}/salons`} component={Salons} />
      <Route path={`${match.url}/vvn`} component={VirtualVetNurse} />
      <Route path={`${match.url}/tourism`} component={Tourism} />
      <Route path={`${match.url}/northable`} component={Northable} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
